import {Form, InputNumber, Modal,  App,  Row, Col, DatePicker, Space   } from 'antd'
import { ASSETS_APPLICATION_BASE } from '../../config/api'
import React, { useEffect,useState } from 'react'
import classes from './loan.module.css'
import { useJiekuanUpdateSaveMutation, useJKtijiaoMutation, useJiekuanUpdateQuery } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';
import ClientBankSelect from '../../system/client/ClientBankSelect';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import Icon from '../../cpn/Icon';
// import LoanWithdraw from './LoanWithdraw';        
import DocumentRule from '../../cpn/DocumentRule';  
import Asterisk from '../../cpn/Asterisk';
import LoanNodeEdit from './LoanNodeEdit';
import LoanDel from './LoanDel';
import ReportStateTag from '../../cpn/StateTag';
import AccountCheck from '../../system/account/AccountCheck';
function LoanEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'jk_price':'',   
        'jk_uid':'',
        'jk_uname':'',
        'jk_content':'',
        'jk_bzd_id':'',
        'jk_qy_id':'',
        'jk_qy_name':'',
        'jk_kh_id':'',
        'jk_kh_name':'',
        'jk_type_id':'',
        'jk_type_name':'',
        'jk_amount':'',
        'jk_bzd_xuhao':'',
        'jk_bzd_name':'',
        'jk_date':'',
        'jk_bzd_date_end':'',
        'jk_num':'',
        'jk_name':'',
        'jk_bzd_date':'',
        'jk_khyhzh_id':'',
        'jk_khyhzh_name':'',
        'jk_image_name':'',
        'jk_image_file':'',
        'jk_bm_id':'',
        'jk_bm_name':'',
        'jk_state':'',
        'jk_ctime':'',
        'jk_state_time':'',
        'jk_zflx':'',
        'jk_qyyhzh_id':'',
        'jk_qyyhzh_name':'',
        'jk_qyyhzh_date':'',
    })
    const {data, isSuccess} = useJiekuanUpdateQuery({jk_id:props.jk_id},{skip:!open});
    const [form] = Form.useForm();
    const [updateSave] = useJiekuanUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'jk_price': data.Result.jk_price,   
                'jk_uid': data.Result.jk_uid,
                'jk_uname': data.Result.jk_uname,
                'jk_content': data.Result.jk_content,
                'jk_bzd_id': data.Result.jk_bzd_id,
                'jk_qy_id': data.Result.jk_qy_id,
                'jk_qy_name': data.Result.jk_qy_name,
                'jk_kh_id': data.Result.jk_kh_id,
                'jk_kh_name': data.Result.jk_kh_name,
                'jk_type_id': data.Result.jk_type_id,
                'jk_type_name': data.Result.jk_type_name,
                'jk_amount': data.Result.jk_amount,
                'jk_bzd_xuhao': data.Result.jk_bzd_xuhao,
                'jk_bzd_name': data.Result.jk_bzd_name,
                'jk_date': data.Result.jk_date,
                'jk_bzd_date_end': data.Result.jk_bzd_date_end,
                'jk_num': data.Result.jk_num,
                'jk_name': data.Result.jk_name,
                'jk_bzd_date': data.Result.jk_bzd_date,
                'jk_khyhzh_id': data.Result.jk_khyhzh_id,
                'jk_khyhzh_name': data.Result.jk_khyhzh_name,
                'jk_image_name': data.Result.jk_image_name,
                'jk_image_file': data.Result.jk_image_file,
                'jk_bm_id': data.Result.jk_bm_id,
                'jk_bm_name': data.Result.jk_bm_name,
                'jk_state': data.Result.jk_state,
                'jk_ctime': data.Result.jk_ctime,
                'jk_state_time': data.Result.jk_state_time,
                'jk_zflx': data.Result.jk_zflx,
                'jk_qyyhzh_id': data.Result.jk_qyyhzh_id,
                'jk_qyyhzh_name': data.Result.jk_qyyhzh_name,
                'jk_qyyhzh_date': data.Result.jk_qyyhzh_date,
            });
            setDefaultFileList(Array.isArray(data.Result.jk_image_name) ? data.Result.jk_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.jk_image_name) 
            ? data.Result.jk_image_name.filter(Boolean)
            : (data.Result.jk_image_name ? [data.Result.jk_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.jk_image_file)
                ? data.Result.jk_image_file.filter(Boolean)
                : (data.Result.jk_image_file ? [data.Result.jk_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                    'jk_price': data.Result.jk_price,  
                    'jk_uid': data.Result.jk_uid,
                    'jk_uname': data.Result.jk_uname,
                    'jk_content': data.Result.jk_content,
                    'jk_bzd_id': data.Result.jk_bzd_id,
                    'jk_bzd_name': data.Result.jk_bzd_name,
                    'jk_kh_id': data.Result.jk_kh_id,
                    'jk_kh_name': data.Result.jk_kh_name,
                    'jk_name': data.Result.jk_name,
                    'jk_type_name': data.Result.jk_type_name,
                    'jk_num': data.Result.jk_num,
                    'jk_bm_name': data.Result.jk_bm_name,
                    'jk_date': dayjs(data.Result.jk_date),
                    'jk_khyhzh_name': data.Result.jk_khyhzh_name,
                    'jk_amount': data.Result.jk_amount,
                    'jk_image_name': imageNameArray,
                    'jk_image_file': fileListForForm,
            })

        }
        
        
        
        
    }, [data, isSuccess,form])    

   
    //提交借款单
    const [tijiao] = useJKtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.jk_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #660099',borderLeft:'3px solid #660099'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#660099',borderTop:'3px solid #660099'}}>借款单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #660099',borderRight:'3px solid #660099'}}></Col>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #660099',color:'#660099'}}>团队名称</Col>
                        <Col span={6}  className={classes.col_top_input} style={props.jk_bzd_name ? {} : {padding: '15px'}}>
                            {info.jk_bzd_name} 
                        </Col>  
                        <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {info.jk_type_name}
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #660099'}}>
                            {info.jk_num}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='jk_date' noStyle>
                               <DatePicker 
                                   placeholder='请选择日期' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, jk_date: value }))
                                   }}
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='jk_amount' noStyle>
                               <InputNumber 
                                   placeholder='请输入金额' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, jk_amount: value }))
                                   }}
                                   style={{ width: '100%' }}
                                   min={0.01}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #660099'}}>
                           <ReportDeptSelect
                               yh_id={props.yh_id}
                               wrapperCol={{span:24}}
                               placeholder='请选择部门'
                               qy_id={props.qy_id}
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, jk_bm_id: e, jk_bm_name: f }))
                               }}
                               name="jk_bm_name"
                               defaultId={info.jk_bm_id}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 借款人</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='jk_kh_id'
                                placeholder='请选择借款客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, jk_kh_id: value, jk_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                defaultId={info.jk_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                        <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #660099'}}>
                            <ClientBankSelect
                               name='jk_khyhzh_name'
                               placeholder='请选择借款客户银行'
                               onChange={(value,label) => {
                                   setInfo(prevState => ({ ...prevState, jk_khyhzh_id: value, jk_khyhzh_name: label }))
                               }}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               wrapperCol={{span:24}}
                               qy_id={props.qy_id}
                               yh_id={props.yh_id}
                               defaultId={info.jk_khyhzh_id}
                               kh_id={info.jk_kh_id}
                           />
                        </Col>
                        {/* 第四行       */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>备注</Col>
                        <Col span={14}  className={classes.col_middle_input}>
                            <Form.Item name='jk_content' noStyle>
                               <OCRTextArea
                                   value={info.jk_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, jk_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                        </Col>      
                        <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #660099'}}>
                           {info.jk_qyyhzh_date} <AccountCheck qyyhzh_id={info.jk_qyyhzh_id} name={info.jk_qyyhzh_name} />
                        </Col>
                        {/* 第五行                             */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>附件</Col>
                        <Col span={14}  className={classes.col_bottom_input}>
                            <UploadPic
                               name='jk_image_file'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, jk_image_file: e, jk_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               defaultFileList={defaultFileList}
                           />
                        </Col>                                   
                        <Col span={2}  className={classes.col_bottom_label}>编号/状态</Col>
                        <Col span={6}  className={classes.col_bottom_right} style={{borderRight:'3px solid #660099'}}>
                           {props.jk_id}&emsp;<ReportStateTag state={props.jk_state} />
                        </Col>   
                        {/* 第六行 */}
                        <Col span={24} className={classes.bottom_row}>
                            <LoanNodeEdit 
                                qy_id={props.qy_id} 
                                user_id={props.yh_id} 
                                yh_name={props.yh_name} 
                                jk_id={props.jk_id} 
                                jk_state={props.jk_state}
                                jk_ctime={info.jk_ctime}
                                jk_uname={info.jk_uname}
                                jk_state_time={props.jk_state_time}
                            />
                        </Col>
                    </Row> 
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.jk_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }                                        
                                        if(info.jk_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.jk_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.jk_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }
                                        updateSave({
                                            'jk_id': props.jk_id,
                                            'jk_price': info.jk_price,
                                            'jk_uid': props.yh_id,
                                            'jk_uname': props.yh_name,
                                            'jk_content': info.jk_content,
                                            'jk_bzd_id': info.jk_bzd_id,
                                            'jk_qy_id': props.qy_id,
                                            'jk_qy_name': props.qy_name,
                                            'jk_kh_id': info.jk_kh_id,
                                            'jk_kh_name': info.jk_kh_name,
                                            'jk_type_id': info.jk_type_id,
                                            'jk_type_name': info.jk_type_name,
                                            'jk_amount': info.jk_amount,
                                            'jk_bzd_xuhao': '',
                                            'jk_bzd_name': info.jk_bzd_name,
                                            'jk_date': info.jk_date,
                                            'jk_bzd_date_end': info.jk_bzd_date_end?info.jk_bzd_date_end:'',
                                            'jk_num': info.jk_num, 
                                            'jk_name': '',
                                            'jk_bzd_date': info.jk_bzd_date?info.jk_bzd_date:'',
                                            'jk_khyhzh_id': info.jk_khyhzh_id,
                                            'jk_khyhzh_name': info.jk_khyhzh_name,
                                            'jk_image_name': info.jk_image_name?info.jk_image_name:'',
                                            'jk_image_file': info.jk_image_file?info.jk_image_file:'',
                                            'jk_bm_id': info.jk_bm_id,
                                            'jk_bm_name': info.jk_bm_name,
                                            'jk_state': '1',
                                            'jk_zflx': '应收',
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                                {/* {props.jk_state === '2' && <LoanWithdraw jk_id={props.jk_id} />} */}
                                {(props.jk_state === '1' || props.jk_state === '4') && <LoanDel jk_id={props.jk_id} />}
                                <Icon 
                                    type='submit' 
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                    
                                        if(props.jk_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }

                                        if(props.jk_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(props.jk_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }

                                        if(props.jk_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(props.jk_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        tijiao({
                                            'jk_id': props.jk_id,
                                            'jk_uid': props.yh_id,  
                                            'jk_uname': props.yh_name,
                                            'qy_id': props.qy_id,
                                            'qy_name': props.qy_name,
                                            'jk_name': '无',
                                            'jk_date': info.jk_date,
                                            'jk_kh_id': info.jk_kh_id, 
                                            'jk_kh_name': info.jk_kh_name,
                                            'jk_sp_jk_amount': info.jk_amount,
                                            'jk_sp_jk_content': info.jk_content,
                                            'jk_sp_dsbzd_id': props.jk_bzd_id,
                                            'jk_sp_dsbzd_name': props.jk_bzd_name,
                                            'jk_bm_id': info.jk_bm_id,
                                            'jk_bm_name': info.jk_bm_name,
                                            'jk_khyhzh_id': info.jk_khyhzh_id,
                                            'jk_khyhzh_name': info.jk_khyhzh_name,
                                            'jk_image_name': info.jk_image_name?info.jk_image_name:'',
                                            'jk_image_file': info.jk_image_file?info.jk_image_file:'',
                                            'jk_spjd_bm_id': info.jk_bm_id,
                                            'jk_spjd_bm_name': info.jk_bm_name,
                                        }).then(res => {
                                            if(res.data.Status === 'success') {
                                                message.success('借款单提交成功！')
                                            } else {
                                                message.error('借款单提交失败！'+res.data.Message)
                                            }
                                        })
                                        .catch((err) => {
                                            message.error('借款单提交失败！'+(err.response?.data?.Message||''))
                                        })
                                        .finally(() => {
                                            setIsSubmitting(false);
                                        })
                                    }} 
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                />  
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default LoanEdit